module.exports = __webpack_public_path__ + "img/SketchPng871191049369103473f8ab12ad255b614220dc5931e5d621f78e1f13153eae78.b446fbf1.png";